/**
 * 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR)
 *
 * WorkspaceFocusMode'un UI'dan bagimsiz, deterministik kademe sozlesmesi.
 */

export type WorkspaceFocusLevel = 'normal' | 'focus' | 'fullscreen';

export function normalizeWorkspaceFocusShortcutKey(value: unknown): string {
    return typeof value === 'string' ? value.toLocaleLowerCase('en-US') : '';
}

const NEXT_WORKSPACE_FOCUS_LEVEL: Record<WorkspaceFocusLevel, WorkspaceFocusLevel> = {
    normal: 'focus',
    focus: 'fullscreen',
    fullscreen: 'normal',
};

const PREVIOUS_WORKSPACE_FOCUS_LEVEL: Record<WorkspaceFocusLevel, WorkspaceFocusLevel> = {
    normal: 'normal',
    focus: 'normal',
    fullscreen: 'focus',
};

export function getNextWorkspaceFocusLevel(
    current: WorkspaceFocusLevel,
): WorkspaceFocusLevel {
    return NEXT_WORKSPACE_FOCUS_LEVEL[current];
}

export function getPreviousWorkspaceFocusLevel(
    current: WorkspaceFocusLevel,
): WorkspaceFocusLevel {
    return PREVIOUS_WORKSPACE_FOCUS_LEVEL[current];
}
